<template>
    <DFormRow
        :label="__('customers.contracts.contract_number')"
        :error="errors.contract_number"
    >
        <DInput
            id="contract_number"
            :model-value="modelValue"
            maxlength="45"
            @update:modelValue="$emit('update:modelValue', $event)"
        />
    </DFormRow>
</template>

<script>
export default {
    name: 'ContractNumber',
    props: {
        modelValue: {
            type: [String, Number],
            default: null
        },
        errors: {
            type: Object,
            default: () => { return {} }
        }
    },
    emits: ['update:modelValue']
}
</script>
